import React from 'react'

const Dsw2 = () => {
    return (
        <div>
        <h1>Search an element in a sorted and rotated array</h1>
        <p>An element in a sorted array can be found in O(log n) time via binary search. But suppose we rotate an ascending order sorted array at some pivot unknown to you beforehand. So for instance, 1 2 3 4 5 might become 3 4 5 1 2. Devise a way to find an element in the rotated array in O(log n) time.<br/>
        &nbsp;</p>
        <p><strong>Example:</strong>&nbsp;<br/>&nbsp;</p>
        <pre className='containers'><strong>Input  :</strong> arr[] ={` {5, 6, 7, 8, 9, 10, 1, 2, 3}`}; <br />
     key = 3 <br />
<strong>Output :</strong> Found at index 8 <br />
<br />
<strong>Input  :</strong> arr[] = {`{5, 6, 7, 8, 9, 10, 1, 2, 3}`}; <br />
     key = 30 <br />
<strong>Output :</strong> Not found <br />
<br />
<strong>Input :</strong> arr[] = {`{30, 40, 50, 10, 20}`} <br />
    key = 10    <br />
<strong>Output :</strong> Found at index 3</pre> <br />
<p><strong><u>Basic Solution:</u></strong>&nbsp;<br/><strong>Approach:</strong>&nbsp;<br/>&nbsp;</p>
<ol><li>The idea is to find the pivot point, divide the array in two sub-arrays and perform binary search.</li>
<li>The main idea for finding pivot is – for a sorted (in increasing order) and pivoted array, pivot element is the only element for which next element to it is smaller than it.</li>
<li>Using the above statement and binary search pivot can be found.</li>
<li>After the pivot is found out divide the array in two sub-arrays.</li>
<li>Now the individual sub – arrays are sorted so the element can be searched using Binary Search.</li>
</ol>
<p><strong>Implementation:</strong>&nbsp;<br/>&nbsp;</p>
<pre>Input arr[] = {`{3, 4, 5, 1, 2}`} <br />
Element to Search = 1 <br />
1) Find out pivot point and divide the array in two <br />
  sub-arrays. (pivot = 2) /*Index of 5*/ <br />
2) Now call binary search for one of the two sub-arrays. <br />
  (a) <strong>If </strong>element is greater than 0th element then <br />
         search in left array <br />
  (b) <strong>Else</strong> Search in right array <br />
      (1 will go in else as 1 &lt; 0th element(3)) <br />
3) <strong>If </strong>element is found in selected sub-array then return index <br />
 <strong>Else </strong>return -1.</pre>

               <div class="tabs">
<input type="radio" name="tab" id="tab1"/>
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>
<input type="radio" name="tab" id="tab4"/>
<label for="tab4">C</label>

<div class="tab-content-wrapper">
  <div id="tab-content-1" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments">/* C++ Program to search an element</code></div>
<div class="line number2 index1 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">in a sorted and pivoted array*/</code></div>
<div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
<div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
        class="keyword bold">namespace</code> <code class="plain">std;</code></div>
<div class="line number5 index4 alt2">&nbsp;</div>
<div class="line number6 index5 alt1"><code class="comments">/* Standard Binary Search function*/</code></div>
<div class="line number7 index6 alt2"><code class="color1 bold">int</code> <code
        class="plain">binarySearch(</code><code class="color1 bold">int</code> <code
        class="plain">arr[], </code><code class="color1 bold">int</code> <code class="plain">low,</code></div>
<div class="line number8 index7 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">high, </code><code class="color1 bold">int</code> <code
        class="plain">key)</code></div>
<div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(high &lt; low)</code></div>
<div class="line number11 index10 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">-1;</code></div>
<div class="line number12 index11 alt1">&nbsp;</div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">mid = (low + high) / 2; </code><code
        class="comments">/*low + (high - low)/2;*/</code></div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(key == arr[mid])</code></div>
<div class="line number15 index14 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">mid;</code></div>
<div class="line number16 index15 alt1">&nbsp;</div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(key &gt; arr[mid])</code></div>
<div class="line number18 index17 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">binarySearch(arr, (mid + 1), high, key);</code></div>
<div class="line number19 index18 alt2">&nbsp;</div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// else</code></div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">binarySearch(arr, low, (mid - 1), key);</code></div>
<div class="line number22 index21 alt1"><code class="plain">&#125;</code></div>
<div class="line number23 index22 alt2">&nbsp;</div>
<div class="line number24 index23 alt1"><code
        class="comments">/* Function to get pivot. For array 3, 4, 5, 6, 1, 2</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">it returns 3 (index of 6) */</code></div>
<div class="line number26 index25 alt1"><code class="color1 bold">int</code> <code
        class="plain">findPivot(</code><code class="color1 bold">int</code> <code class="plain">arr[], </code><code
        class="color1 bold">int</code> <code class="plain">low, </code><code class="color1 bold">int</code> <code
        class="plain">high)</code></div>
<div class="line number27 index26 alt2"><code class="plain">&#123;</code></div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// base cases</code></div>
<div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(high &lt; low)</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">-1;</code></div>
<div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(high == low)</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">low;</code></div>
<div class="line number33 index32 alt2">&nbsp;</div>
<div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">mid = (low + high) / 2; </code><code
        class="comments">/*low + (high - low)/2;*/</code></div>
<div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code
        class="plain">(mid &lt; high &amp;&amp; arr[mid] &gt; arr[mid + 1])</code></div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">mid;</code></div>
<div class="line number37 index36 alt2">&nbsp;</div>
<div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code
        class="plain">(mid &gt; low &amp;&amp; arr[mid] &lt; arr[mid - 1])</code></div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">(mid - 1);</code></div>
<div class="line number40 index39 alt1">&nbsp;</div>
<div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(arr[low] &gt;= arr[mid])</code></div>
<div class="line number42 index41 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">findPivot(arr, low, mid - 1);</code></div>
<div class="line number43 index42 alt2">&nbsp;</div>
<div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">findPivot(arr, mid + 1, high);</code></div>
<div class="line number45 index44 alt2"><code class="plain">&#125;</code></div>
<div class="line number46 index45 alt1">&nbsp;</div>
<div class="line number47 index46 alt2"><code class="comments">/* Searches an element key in a pivoted</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">sorted array arr[] of size n */</code></div>
<div class="line number49 index48 alt2"><code class="color1 bold">int</code> <code
        class="plain">pivotedBinarySearch(</code><code class="color1 bold">int</code> <code
        class="plain">arr[], </code><code class="color1 bold">int</code> <code class="plain">n, </code><code
        class="color1 bold">int</code> <code class="plain">key)</code></div>
<div class="line number50 index49 alt1"><code class="plain">&#123;</code></div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">pivot = findPivot(arr, 0, n - 1);</code></div>
<div class="line number52 index51 alt1">&nbsp;</div>
<div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If we didn't find a pivot,</code></div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// then array is not rotated at all</code></div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(pivot == -1)</code></div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">binarySearch(arr, 0, n - 1, key);</code></div>
<div class="line number57 index56 alt2">&nbsp;</div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If we found a pivot, then first compare with pivot</code></div>
<div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// and then search in two subarrays around pivot</code></div>
<div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(arr[pivot] == key)</code></div>
<div class="line number61 index60 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">pivot;</code></div>
<div class="line number62 index61 alt1">&nbsp;</div>
<div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(arr[0] &lt;= key)</code></div>
<div class="line number64 index63 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">binarySearch(arr, 0, pivot - 1, key);</code></div>
<div class="line number65 index64 alt2">&nbsp;</div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">binarySearch(arr, pivot + 1, n - 1, key);</code>
</div>
<div class="line number67 index66 alt2"><code class="plain">&#125;</code></div>
<div class="line number68 index67 alt1">&nbsp;</div>
<div class="line number69 index68 alt2"><code class="comments">/* Driver program to check above functions */</code>
</div>
<div class="line number70 index69 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number71 index70 alt2"><code class="plain">&#123;</code></div>
<div class="line number72 index71 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Let us search 3 in below array</code></div>
<div class="line number73 index72 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">arr1[] = &#123; 5, 6, 7, 8, 9, 10, 1, 2, 3 &#125;;</code></div>
<div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">n = </code><code class="keyword bold">sizeof</code><code
        class="plain">(arr1) / </code><code class="keyword bold">sizeof</code><code class="plain">(arr1[0]);</code>
</div>
<div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">key = 3;</code></div>
<div class="line number76 index75 alt1">&nbsp;</div>
<div class="line number77 index76 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Function calling</code></div>
<div class="line number78 index77 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; </code><code class="string">"Index of the element is : "</code></div>
<div class="line number79 index78 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&lt;&lt; pivotedBinarySearch(arr1, n, key);</code></div>
<div class="line number80 index79 alt1">&nbsp;</div>
<div class="line number81 index80 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number82 index81 alt1"><code class="plain">&#125;</code></div>
</div>
  </div>
  <div id="tab-content-2" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments">/* Java program to search an element</code></div>
<div class="line number2 index1 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">in a sorted and pivoted array*/</code></div>
<div class="line number3 index2 alt2">&nbsp;</div>
<div class="line number4 index3 alt1"><code class="keyword">class</code> <code class="plain">Main &#123;</code></div>
<div class="line number5 index4 alt2">&nbsp;</div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Searches an element key in a</code></div>
<div class="line number7 index6 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">pivoted sorted array arrp[]</code></div>
<div class="line number8 index7 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">of size n */</code></div>
<div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">static</code> <code class="keyword">int</code> <code
        class="plain">pivotedBinarySearch(</code><code class="keyword">int</code> <code
        class="plain">arr[], </code><code class="keyword">int</code> <code class="plain">n, </code><code
        class="keyword">int</code> <code class="plain">key)</code></div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number11 index10 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">pivot = findPivot(arr, </code><code
        class="value">0</code><code class="plain">, n - </code><code class="value">1</code><code
        class="plain">);</code></div>
<div class="line number12 index11 alt1">&nbsp;</div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If we didn't find a pivot, then</code></div>
<div class="line number14 index13 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// array is not rotated at all</code></div>
<div class="line number15 index14 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(pivot == -</code><code class="value">1</code><code
        class="plain">)</code></div>
<div class="line number16 index15 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">binarySearch(arr, </code><code class="value">0</code><code
        class="plain">, n - </code><code class="value">1</code><code class="plain">, key);</code></div>
<div class="line number17 index16 alt2">&nbsp;</div>
<div class="line number18 index17 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If we found a pivot, then first</code></div>
<div class="line number19 index18 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// compare with pivot and then</code></div>
<div class="line number20 index19 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// search in two subarrays around pivot</code></div>
<div class="line number21 index20 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(arr[pivot] == key)</code></div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">pivot;</code></div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(arr[</code><code class="value">0</code><code
        class="plain">] &lt;= key)</code></div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">binarySearch(arr, </code><code class="value">0</code><code
        class="plain">, pivot - </code><code class="value">1</code><code class="plain">, key);</code></div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">binarySearch(arr, pivot + </code><code
        class="value">1</code><code class="plain">, n - </code><code class="value">1</code><code
        class="plain">, key);</code></div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number27 index26 alt2">&nbsp;</div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Function to get pivot. For array</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">3, 4, 5, 6, 1, 2 it returns</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">3 (index of 6) */</code></div>
<div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">static</code> <code class="keyword">int</code> <code class="plain">findPivot(</code><code
        class="keyword">int</code> <code class="plain">arr[], </code><code class="keyword">int</code> <code
        class="plain">low, </code><code class="keyword">int</code> <code class="plain">high)</code></div>
<div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// base cases</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(high &lt; low)</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">-</code><code class="value">1</code><code
        class="plain">;</code></div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(high == low)</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">low;</code></div>
<div class="line number38 index37 alt1">&nbsp;</div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* low + (high - low)/2; */</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">mid = (low + high) / </code><code class="value">2</code><code
        class="plain">;</code></div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(mid &lt; high &amp;&amp; arr[mid] &gt; arr[mid + </code><code
        class="value">1</code><code class="plain">])</code></div>
<div class="line number42 index41 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">mid;</code></div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(mid &gt; low &amp;&amp; arr[mid] &lt; arr[mid - </code><code
        class="value">1</code><code class="plain">])</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">(mid - </code><code class="value">1</code><code
        class="plain">);</code></div>
<div class="line number45 index44 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(arr[low] &gt;= arr[mid])</code></div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">findPivot(arr, low, mid - </code><code
        class="value">1</code><code class="plain">);</code></div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">findPivot(arr, mid + </code><code
        class="value">1</code><code class="plain">, high);</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number49 index48 alt2">&nbsp;</div>
<div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Standard Binary Search function */</code></div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">static</code> <code class="keyword">int</code> <code class="plain">binarySearch(</code><code
        class="keyword">int</code> <code class="plain">arr[], </code><code class="keyword">int</code> <code
        class="plain">low, </code><code class="keyword">int</code> <code class="plain">high, </code><code
        class="keyword">int</code> <code class="plain">key)</code></div>
<div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number53 index52 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(high &lt; low)</code></div>
<div class="line number54 index53 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">-</code><code class="value">1</code><code
        class="plain">;</code></div>
<div class="line number55 index54 alt2">&nbsp;</div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* low + (high - low)/2; */</code></div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">mid = (low + high) / </code><code class="value">2</code><code
        class="plain">;</code></div>
<div class="line number58 index57 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(key == arr[mid])</code></div>
<div class="line number59 index58 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">mid;</code></div>
<div class="line number60 index59 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(key &gt; arr[mid])</code></div>
<div class="line number61 index60 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">binarySearch(arr, (mid + </code><code
        class="value">1</code><code class="plain">), high, key);</code></div>
<div class="line number62 index61 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">binarySearch(arr, low, (mid - </code><code
        class="value">1</code><code class="plain">), key);</code></div>
<div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number64 index63 alt1">&nbsp;</div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// main function</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">main(String args[])</code></div>
<div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number68 index67 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Let us search 3 in below array</code></div>
<div class="line number69 index68 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">arr1[] = &#123; </code><code class="value">5</code><code
        class="plain">, </code><code class="value">6</code><code class="plain">, </code><code
        class="value">7</code><code class="plain">, </code><code class="value">8</code><code
        class="plain">, </code><code class="value">9</code><code class="plain">, </code><code
        class="value">10</code><code class="plain">, </code><code class="value">1</code><code
        class="plain">, </code><code class="value">2</code><code class="plain">, </code><code class="value">3</code>
    <code class="plain">&#125;;</code></div>
<div class="line number70 index69 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">n = arr1.length;</code></div>
<div class="line number71 index70 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">key = </code><code class="value">3</code><code
        class="plain">;</code></div>
<div class="line number72 index71 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(</code><code class="string">"Index of the element is : "</code></div>
<div class="line number73 index72 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">+ pivotedBinarySearch(arr1, n, key));</code></div>
<div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number75 index74 alt2"><code class="plain">&#125;</code></div>
</div>
    </div>
  <div id="tab-content-3" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments"># Python Program to search an element</code></div>
<div class="line number2 index1 alt1"><code class="comments"># in a sorted and pivoted array</code></div>
<div class="line number3 index2 alt2">&nbsp;</div>
<div class="line number4 index3 alt1"><code class="comments"># Searches an element key in a pivoted</code></div>
<div class="line number5 index4 alt2"><code class="comments"># sorted array arrp[] of size n</code></div>
<div class="line number6 index5 alt1"><code class="keyword">def</code> <code
        class="plain">pivotedBinarySearch(arr, n, key):</code></div>
<div class="line number7 index6 alt2">&nbsp;</div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">pivot </code><code class="keyword">=</code> <code class="plain">findPivot(arr, </code><code
        class="value">0</code><code class="plain">, n</code><code class="keyword">-</code><code
        class="value">1</code><code class="plain">);</code></div>
<div class="line number9 index8 alt2">&nbsp;</div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># If we didn't find a pivot,</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># then array is not rotated at all</code></div>
<div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">pivot </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="keyword">-</code><code class="value">1</code><code
        class="plain">:</code></div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">binarySearch(arr, </code><code class="value">0</code><code
        class="plain">, n</code><code class="keyword">-</code><code class="value">1</code><code
        class="plain">, key);</code></div>
<div class="line number14 index13 alt1">&nbsp;</div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># If we found a pivot, then first</code></div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># compare with pivot and then</code></div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># search in two subarrays around pivot</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">arr[pivot] </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="plain">key:</code></div>
<div class="line number19 index18 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">pivot</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">arr[</code><code class="value">0</code><code
        class="plain">] &lt;</code><code class="keyword">=</code> <code class="plain">key:</code></div>
<div class="line number21 index20 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">binarySearch(arr, </code><code class="value">0</code><code
        class="plain">, pivot</code><code class="keyword">-</code><code class="value">1</code><code
        class="plain">, key);</code></div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">binarySearch(arr, pivot </code><code
        class="keyword">+</code> <code class="value">1</code><code class="plain">, n</code><code
        class="keyword">-</code><code class="value">1</code><code class="plain">, key);</code></div>
<div class="line number23 index22 alt2">&nbsp;</div>
<div class="line number24 index23 alt1">&nbsp;</div>
<div class="line number25 index24 alt2"><code class="comments"># Function to get pivot. For array</code></div>
<div class="line number26 index25 alt1"><code class="comments"># 3, 4, 5, 6, 1, 2 it returns 3</code></div>
<div class="line number27 index26 alt2"><code class="comments"># (index of 6)</code></div>
<div class="line number28 index27 alt1"><code class="keyword">def</code> <code
        class="plain">findPivot(arr, low, high):</code></div>
<div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># base cases</code></div>
<div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">high &lt; low:</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="keyword">-</code><code class="value">1</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">high </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="plain">low:</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">low</code></div>
<div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># low + (high - low)/2;</code></div>
<div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">mid </code><code class="keyword">=</code> <code class="functions">int</code><code
        class="plain">((low </code><code class="keyword">+</code> <code class="plain">high)</code><code
        class="keyword">/</code><code class="value">2</code><code class="plain">)</code></div>
<div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">mid &lt; high </code><code class="keyword">and</code> <code
        class="plain">arr[mid] &gt; arr[mid </code><code class="keyword">+</code> <code class="value">1</code><code
        class="plain">]:</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">mid</code></div>
<div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">mid &gt; low </code><code class="keyword">and</code> <code
        class="plain">arr[mid] &lt; arr[mid </code><code class="keyword">-</code> <code class="value">1</code><code
        class="plain">]:</code></div>
<div class="line number42 index41 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">(mid</code><code class="keyword">-</code><code
        class="value">1</code><code class="plain">)</code></div>
<div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">arr[low] &gt;</code><code class="keyword">=</code> <code
        class="plain">arr[mid]:</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">findPivot(arr, low, mid</code><code
        class="keyword">-</code><code class="value">1</code><code class="plain">)</code></div>
<div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">findPivot(arr, mid </code><code class="keyword">+</code>
    <code class="value">1</code><code class="plain">, high)</code></div>
<div class="line number46 index45 alt1">&nbsp;</div>
<div class="line number47 index46 alt2"><code class="comments"># Standard Binary Search function*/</code></div>
<div class="line number48 index47 alt1"><code class="keyword">def</code> <code
        class="plain">binarySearch(arr, low, high, key):</code></div>
<div class="line number49 index48 alt2">&nbsp;</div>
<div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">high &lt; low:</code></div>
<div class="line number51 index50 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="keyword">-</code><code class="value">1</code></div>
<div class="line number52 index51 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># low + (high - low)/2;&nbsp;&nbsp;&nbsp;</code></div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">mid </code><code class="keyword">=</code> <code class="functions">int</code><code
        class="plain">((low </code><code class="keyword">+</code> <code class="plain">high)</code><code
        class="keyword">/</code><code class="value">2</code><code class="plain">)</code></div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number56 index55 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">key </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="plain">arr[mid]:</code></div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">mid</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">key &gt; arr[mid]:</code></div>
<div class="line number59 index58 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">binarySearch(arr, (mid </code><code
        class="keyword">+</code> <code class="value">1</code><code class="plain">), high,</code></div>
<div class="line number60 index59 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">key);</code></div>
<div class="line number61 index60 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">binarySearch(arr, low, (mid </code><code
        class="keyword">-</code><code class="value">1</code><code class="plain">), key);</code></div>
<div class="line number62 index61 alt1">&nbsp;</div>
<div class="line number63 index62 alt2">&nbsp;</div>
<div class="line number64 index63 alt1"><code class="comments"># Driver program to check above functions */</code>
</div>
<div class="line number65 index64 alt2"><code class="comments"># Let us search 3 in below array</code></div>
<div class="line number66 index65 alt1"><code class="plain">arr1 </code><code class="keyword">=</code> <code
        class="plain">[</code><code class="value">5</code><code class="plain">, </code><code
        class="value">6</code><code class="plain">, </code><code class="value">7</code><code
        class="plain">, </code><code class="value">8</code><code class="plain">, </code><code
        class="value">9</code><code class="plain">, </code><code class="value">10</code><code
        class="plain">, </code><code class="value">1</code><code class="plain">, </code><code
        class="value">2</code><code class="plain">, </code><code class="value">3</code><code class="plain">]</code>
</div>
<div class="line number67 index66 alt2"><code class="plain">n </code><code class="keyword">=</code> <code
        class="functions">len</code><code class="plain">(arr1)</code></div>
<div class="line number68 index67 alt1"><code class="plain">key </code><code class="keyword">=</code> <code
        class="value">3</code></div>
<div class="line number69 index68 alt2"><code class="functions">print</code><code class="plain">(</code><code
        class="string">"Index of the element is : "</code><code class="plain">,</code></div>
<div class="line number70 index69 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">pivotedBinarySearch(arr1, n, key))</code></div>
<div class="line number71 index70 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number72 index71 alt1"><code class="comments"># This is contributed by Smitha Dinesh Semwal</code>
</div>
</div>
    </div>
 
   
  <div id="tab-content-4" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments">/* Program to search an element in</code></div>
<div class="line number2 index1 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">a sorted and pivoted array*/</code></div>
<div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;stdio.h&gt;</code></div>
<div class="line number4 index3 alt1">&nbsp;</div>
<div class="line number5 index4 alt2"><code class="color1 bold">int</code> <code
        class="plain">findPivot(</code><code class="color1 bold">int</code><code class="plain">[], </code><code
        class="color1 bold">int</code><code class="plain">, </code><code class="color1 bold">int</code><code
        class="plain">);</code></div>
<div class="line number6 index5 alt1"><code class="color1 bold">int</code> <code
        class="plain">binarySearch(</code><code class="color1 bold">int</code><code class="plain">[], </code><code
        class="color1 bold">int</code><code class="plain">, </code><code class="color1 bold">int</code><code
        class="plain">, </code><code class="color1 bold">int</code><code class="plain">);</code></div>
<div class="line number7 index6 alt2">&nbsp;</div>
<div class="line number8 index7 alt1"><code class="comments">/* Searches an element key in a pivoted</code></div>
<div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">sorted array arrp[] of size n */</code></div>
<div class="line number10 index9 alt1"><code class="color1 bold">int</code> <code
        class="plain">pivotedBinarySearch(</code><code class="color1 bold">int</code> <code
        class="plain">arr[], </code><code class="color1 bold">int</code> <code class="plain">n, </code><code
        class="color1 bold">int</code> <code class="plain">key)</code></div>
<div class="line number11 index10 alt2"><code class="plain">&#123;</code></div>
<div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">pivot = findPivot(arr, 0, n - 1);</code></div>
<div class="line number13 index12 alt2">&nbsp;</div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If we didn't find a pivot,</code></div>
<div class="line number15 index14 alt2"><code class="comments">// then array is not rotated at all</code></div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(pivot == -1)</code></div>
<div class="line number17 index16 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">binarySearch(arr, 0, n - 1, key);</code></div>
<div class="line number18 index17 alt1">&nbsp;</div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If we found a pivot, then first</code></div>
<div class="line number20 index19 alt1"><code class="comments">// compare with pivot and then</code></div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// search in two subarrays around pivot</code></div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(arr[pivot] == key)</code></div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">pivot;</code></div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(arr[0] &lt;= key)</code></div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">binarySearch(arr, 0, pivot - 1, key);</code></div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">binarySearch(arr, pivot + 1, n - 1, key);</code>
</div>
<div class="line number27 index26 alt2"><code class="plain">&#125;</code></div>
<div class="line number28 index27 alt1">&nbsp;</div>
<div class="line number29 index28 alt2"><code class="comments">/* Function to get pivot. For array</code></div>
<div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">3, 4, 5, 6, 1, 2 it returns 3 (index of 6) */</code></div>
<div class="line number31 index30 alt2"><code class="color1 bold">int</code> <code
        class="plain">findPivot(</code><code class="color1 bold">int</code> <code class="plain">arr[], </code><code
        class="color1 bold">int</code> <code class="plain">low, </code><code class="color1 bold">int</code> <code
        class="plain">high)</code></div>
<div class="line number32 index31 alt1"><code class="plain">&#123;</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// base cases</code></div>
<div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(high &lt; low)</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">-1;</code></div>
<div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(high == low)</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">low;</code></div>
<div class="line number38 index37 alt1">&nbsp;</div>
<div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">mid = (low + high) / 2; </code><code
        class="comments">/*low + (high - low)/2;*/</code></div>
<div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code
        class="plain">(mid &lt; high &amp;&amp; arr[mid] &gt; arr[mid + 1])</code></div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">mid;</code></div>
<div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code
        class="plain">(mid &gt; low &amp;&amp; arr[mid] &lt; arr[mid - 1])</code></div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">(mid - 1);</code></div>
<div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(arr[low] &gt;= arr[mid])</code></div>
<div class="line number45 index44 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">findPivot(arr, low, mid - 1);</code></div>
<div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">findPivot(arr, mid + 1, high);</code></div>
<div class="line number47 index46 alt2"><code class="plain">&#125;</code></div>
<div class="line number48 index47 alt1">&nbsp;</div>
<div class="line number49 index48 alt2"><code class="comments">/* Standard Binary Search function*/</code></div>
<div class="line number50 index49 alt1"><code class="color1 bold">int</code> <code
        class="plain">binarySearch(</code><code class="color1 bold">int</code> <code
        class="plain">arr[], </code><code class="color1 bold">int</code> <code class="plain">low, </code><code
        class="color1 bold">int</code> <code class="plain">high, </code><code class="color1 bold">int</code> <code
        class="plain">key)</code></div>
<div class="line number51 index50 alt2"><code class="plain">&#123;</code></div>
<div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(high &lt; low)</code></div>
<div class="line number53 index52 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">-1;</code></div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">mid = (low + high) / 2; </code><code
        class="comments">/*low + (high - low)/2;*/</code></div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(key == arr[mid])</code></div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">mid;</code></div>
<div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(key &gt; arr[mid])</code></div>
<div class="line number58 index57 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">binarySearch(arr, (mid + 1), high, key);</code></div>
<div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">binarySearch(arr, low, (mid - 1), key);</code></div>
<div class="line number60 index59 alt1"><code class="plain">&#125;</code></div>
<div class="line number61 index60 alt2">&nbsp;</div>
<div class="line number62 index61 alt1"><code class="comments">/* Driver program to check above functions */</code>
</div>
<div class="line number63 index62 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number64 index63 alt1"><code class="plain">&#123;</code></div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Let us search 3 in below array</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">arr1[] = &#123; 5, 6, 7, 8, 9, 10, 1, 2, 3 &#125;;</code></div>
<div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">n = </code><code class="keyword bold">sizeof</code><code
        class="plain">(arr1) / </code><code class="keyword bold">sizeof</code><code class="plain">(arr1[0]);</code>
</div>
<div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">key = 3;</code></div>
<div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code
        class="string">"Index of the element is : %d"</code><code class="plain">,</code></div>
<div class="line number70 index69 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">pivotedBinarySearch(arr1, n, key));</code></div>
<div class="line number71 index70 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number72 index71 alt1"><code class="plain">&#125;</code></div>
</div>
    </div>
    </div>
</div>
    </div>
    )
}

export default Dsw2
